export * from './ProductDetailsCardCarouselSlide';
